module.exports = __webpack_public_path__ + "static/media/banner.dce6cba6.jpg";